/**
 * @changelog
 *
 * 2026-03-11 (0.1.0) (jhoward)
 *   - Add App\Helpers\getWebAuthnChallenge() to request WebAuthn challenge for enrollment or authentication.
 *   - Handles response and error messaging.
 *
 * 2026-03-24 (0.1.1) (jhoward)
 *   - Use peppermillCustomFetchProxy instead of peppermillCustomFetch for challenge requests.
 */

import type { FetchResponse } from '@framework/defs/framework';
import peppermillCustomFetchProxy from '@/helpers/peppermillCustomFetchProxy';
import { challenge } from '@rss/actions/App/Http/Controllers/WebAuthnController';

export type RequestType = 'enrollment' | 'authentication';

export interface WebAuthnAuthenticationChallenge {
  publicKey: PublicKeyCredentialRequestOptions & { [key: string]: any };
  mediation?: CredentialMediationRequirement;
  signal?: AbortSignal;
}

export default async function getWebAuthnChallenge<T extends CredentialCreationOptions | CredentialRequestOptions>(
  requestType: RequestType,
  showLoadingSpinner: boolean = true,
): Promise<T | string> {
  const response = await peppermillCustomFetchProxy<FetchResponse & { data: T }>(
    {},
    {
      route: challenge({ requestType }),
      showLoadingSpinner,
    },
  );

  if (response && 200 === response.status) {
    return response.data;
  }
  return response?.message?.length ? response.message : 'An error occurred while requesting the challenge.';
}
